// extracted by mini-css-extract-plugin
export default {"authContainer":"auth-layout_authContainer__bWyc2","header":"auth-layout_header__bWpqc","container":"auth-layout_container__-wVZ3","mainImg":"auth-layout_mainImg__xDLTW"};